import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

@Component({
  selector: 'exg-opt',
  templateUrl: './exg-opt.component.html'
})
export class ExgOptComponent implements OnInit {

  @Input() disabled!: string;
  @Input() caption!: string;
  @Input() name!: string;
  @Input() optValue: any;
  @Input() value: any;
  @Output() valueChange = new EventEmitter();

  id = Math.random().toString(36).substring(2);

  constructor() {
  }

  ngOnInit(): void {

  }

  change(newValue: any): void {
    this.value = newValue;
    this.valueChange.emit(newValue);
  }
}
